import { createSlice } from '@reduxjs/toolkit';
import { startOver } from 'actions/main';

import type { RootState } from '../root';
import initialState from './initialState';
export interface AnswerType {
  confidence_level?: string;
  confidence_score?: number;
  date_created?: string;
  date_updated?: string;
  document_id: string;
  full_html?: string;
  link: string | null;
  preview: string;
  source_type: string;
  span_id?: string;
  standardized_document_id?: string;
  title: string;
  trace_id?: string;
}

export interface AnswersState {
  data: Array<AnswerType>;
  ticketDescription: string;
}

const answersSlice = createSlice({
  extraReducers: builder => {
    builder.addCase(startOver, () => ({
      ...initialState,
    }));
  },
  initialState,
  name: 'answers',
  reducers: {},
});

const selectData = (state: RootState): AnswersState['data'] =>
  state.answers.data;

export { answersSlice, selectData };
